export const formsRequired = {
    attorney_location: {
        email: false,
        phone: true,
        ext: false,
        cell_phone: false,
        fax: true,
        address_line_1: true,
        address_line_2: false,
        state: true,
        county: true,
        city: true,
        zip_code: true
    },
    location: {
        email: false,
        phone: true,
        ext: false,
        cell_phone: false,
        fax: true,
        address_line_1: true,
        address_line_2: false,
        state: true,
        county: true,
        city: true,
        zip_code: true
    },
    attorney: {
        email: true,
        phone: true,
        ext: false,
        cell_phone: false,
        fax: false,
        address_line_1: false,
        address_line_2: false,
        state: false,
        county: false,
        city: false,
        zip_code: false
    },
    case_manager: {
        email: true,
        phone: true,
        ext: false,
        cell_phone: false,
        fax: true,
        address_line_1: false,
        address_line_2: false,
        state: false,
        county: false,
        city: false,
        zip_code: false
    },
    nurse: {
        email: true,
        phone: true,
        ext: false,
        cell_phone: false,
        fax: true,
        address_line_1: false,
        address_line_2: false,
        state: false,
        county: false,
        city: false,
        zip_code: false
    },    
    adjuster: {
        email: false,
        phone: true,
        ext: false,
        cell_phone: false,
        fax: false,
        address_line_1: false,
        address_line_2: false,
        state: false,
        county: false,
        city: false,
        zip_code: false
    },
    negotiator: {
        email: true,
        phone: true,
        ext: false,
        cell_phone: false,
        fax: true,
        address_line_1: false,
        address_line_2: false,
        state: false,
        county: false,
        city: false,
        zip_code: false
    }
}